// libs
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
// types
import { IUser } from 'types/graphql'
import { Reducers } from 'store/types'

export interface CurrentUserState {
  data: IUser & {
    isAuthorized: boolean
  }
}

const initialState: CurrentUserState = {
  data: {
    isAuthorized: false
  }
}

export const currentUserSlice = createSlice({
  name: Reducers.CURREN_USER,
  initialState,
  reducers: (create) => ({
      setCurrentUser: create.reducer((state, action: PayloadAction<IUser>) => {
        state.data = { ...action.payload, isAuthorized: true }
      }),
      removeCurrentUser: create.reducer(
        (state) => {
          state.data = {
            isAuthorized: false
          }
        })
    }
  ),
  selectors: {
    currentUser: (state) => state.data
  }
})

export const {
  setCurrentUser,
  removeCurrentUser
} =
  currentUserSlice.actions

export const { currentUser } = currentUserSlice.selectors
